import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PreviewBar } from '@/components/PreviewBar';
import { HomePage } from '@/pages/HomePage';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Context pour le mode preview
import { createContext, useContext } from 'react';

const PreviewContext = createContext({ isPreview: false });

export const usePreviewContext = () => useContext(PreviewContext);

export function PreviewPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  const token = searchParams.get('token');
  
  // Validate token
  useEffect(() => {
    const validateToken = async () => {
      if (!token) {
        navigate('/admin');
        return;
      }
      
      try {
        const response = await fetch(`${API_URL}/api/admin/preview/validate?token=${token}`);
        const data = await response.json();
        
        if (data.valid) {
          setIsValid(true);
        } else {
          navigate('/admin');
        }
      } catch (err) {
        console.error('Token validation failed:', err);
        navigate('/admin');
      } finally {
        setIsLoading(false);
      }
    };
    
    validateToken();
  }, [token, navigate]);
  
  if (isLoading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }
  
  if (!isValid) {
    return null;
  }
  
  return (
    <PreviewContext.Provider value={{ isPreview: true }}>
      <div className="min-h-screen">
        {/* Barre de preview flottante */}
        <PreviewBar />
        
        {/* Spacer pour la barre de preview */}
        <div className="h-12" />
        
        {/* Storefront avec indication de preview */}
        <HomePage isPreviewMode={true} />
      </div>
    </PreviewContext.Provider>
  );
}

export default PreviewPage;
